<!--
 * @Descripttion: 备件出库详情页面 table
 * @version: 
 * @Author: qiang.xie
 * @Date: 2022-07-24 20:57:25
 * @LastEditors: qiang.xie
 * @LastEditTime: 2022-07-24 23:03:50
-->
<template>
  <div>
    <a-table
      ref="table"
      :scroll="{
        x: `${columns.length}0%`,
        y:270
      }"
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :rowSelection="null"
      :loading="loading"
      style="margin-top: 8px;"
      >
    </a-table>
    </div>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
  name: 'bpBjLeadoutList',
  props:{
    triggerId:{
      type: String,
      default: ''
    }
  },
  data(){
    return {
      dataSource:[],
      loading: false,
      columns:[
        {
          title: '备件名称',
          align: 'center',
          dataIndex: 'bjName'
        },
        {
          title: '领用数量',
          align: 'center',
          dataIndex: 'count'
        },
        {
          title: '单位',
          align: 'center',
          dataIndex: 'unit'
        },
        {
          title: '单价',
          align: 'center',
          dataIndex: 'price'
        },
        {
          title: '总价',
          align: 'center',
          dataIndex: 'cost'
        },
        {
          title: '设备名称',
          align: 'center',
          dataIndex: 'devName'
        },
      ]
    }
  },
  mounted(){
  },
  methods:{
    getData(triggerId){
      this.loading = true
      if(!triggerId){
        return false
      }
      getAction('/spareparts/devBpbjLeadoutRecord/queryDevBpbjLeadoutListByMainId' + '?id=' + triggerId)
      .then(res => {
        this.dataSource = res.result || []
        this.loading = false
      })
      .catch(() => {
        this.loading = false
      })
    }
  }
}
</script>